import { FC, ReactElement } from 'react';
import { Modal } from 'react-bootstrap';
import i18next from 'i18next';
import AppModal from '../app-modal/AppModal';
import PromQuestionForm from './PromQuestionForm';
import { PromQuestionDto } from '../../../../shared/dtos/prom.dto';

type PromQuestionModalProps = {
  show: boolean;
  promQuestion?: PromQuestionDto;
  onClose: () => void;
  onSave: () => void;
}

const PromQuestionModal: FC<PromQuestionModalProps> = ({
  show,
  promQuestion,
  onClose,
  onSave
}: PromQuestionModalProps): ReactElement => {

  return (
    <AppModal size="xl" show={show} onHide={onClose} backdrop="static" keyboard>
      <Modal.Header closeButton>
        <Modal.Title>
          {i18next.t(promQuestion ? 'promQuestionModal.updateQuestion' : 'promQuestionModal.createQuestion')}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <PromQuestionForm
          initialData={promQuestion}
          onClose={onClose}
          onSubmit={() => {
            onSave();
            onClose();
          }}
        />
      </Modal.Body>
    </AppModal>
  );
};

export default PromQuestionModal;
